import { useRef } from "react";

import { useStore } from "hooks";

import { ItemSelector } from "components/panes/ItemSelector";
import { ModalActionsWrapper } from "components/ui/layout";
import PaneNavigator from "components/ui/pane-navigator";
import CreateCategory from "./create-category";
import { useQuery } from "@tanstack/react-query";

export default function SelectCategory({ onChange, onCancel, subjectId }) {
  const { profileStore } = useStore();
  const { categories } = profileStore;
  const navigator = useRef();

  const { data: frequentlyUsedCategories } = useQuery({
    queryKey: ["subjectCategories", subjectId],
    queryFn: () =>
      profileStore.getFrequentlyUsedCategoriesForSubject(subjectId),
    refetchOnWindowFocus: false,
  });

  const goBack = () => {
    navigator.current.goBack();
  };

  const handleCreateCategory = (createData) => {
    onChange(createData);
  };

  const openCreateCategory = () => {
    navigator.current.navigateTo(
      <CreateCategory
        profileId={profileStore.selectedProfile}
        onCancel={goBack}
        onComplete={handleCreateCategory}
      />
    );
  };

  return (
    <PaneNavigator ref={navigator}>
      <ModalActionsWrapper onCreate={openCreateCategory} onCancel={onCancel}>
        <ItemSelector
          onChange={onChange}
          items={categories.all || []}
          frequentlyUsed={
            frequentlyUsedCategories && frequentlyUsedCategories.length
              ? frequentlyUsedCategories
              : categories.frequentlyUsed || []
          }
          showIndex
        />
      </ModalActionsWrapper>
    </PaneNavigator>
  );
}
